import { render, staticRenderFns } from "./SyntheticMediaImageReference.vue?vue&type=template&id=88534050&scoped=true"
import script from "./SyntheticMediaImageReference.vue?vue&type=script&lang=js"
export * from "./SyntheticMediaImageReference.vue?vue&type=script&lang=js"
import style0 from "./SyntheticMediaImageReference.vue?vue&type=style&index=0&id=88534050&prod&scoped=true&lang=css"
import style1 from "./SyntheticMediaImageReference.vue?vue&type=style&index=1&id=88534050&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88534050",
  null
  
)

export default component.exports